<template>
      <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1>Pridelovalec</h1>
      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">
<div v-if="!pridelovalecid">
    NI PODATKOV
</div>
<div v-else>
<div>
        <div :style="{ display: 'inline-block' }">
            Sezona
            <br />
            <dropdownlist
                :data-items="sezonePisanje"
                :text-field="'sezona'"
                @change="sezonaChange"
                :value="dataSezona"
            />
                <pridelovalec :pridelovalec="pridelovalec"  shema="EKO PRI" :sezona="parseInt(dataSezona.sezona)">
          </pridelovalec>
            
          </div>
        </div>
 <div class="uporabnik-spacer" style="margin-top:2rem"></div>
<div class="">
<form @submit.prevent="handleSubmit" class="k-form">
            <div class="form-group">
                  <div class="km-widget km-buttongroup k-widget k-button-group">
                <button class="k-button k-primary" :disabled="pridelovalec.pisanje==0" @click="saveData" >Shrani</button>
                <button class="k-button k-primary" @click="nazaj" >Nazaj</button>
               </div>
             </div>



<div>
  <fieldset class="left-border-for-children">
            <div class="form-fieldset-header">
                <h2>Prijava in obseg certificiranja</h2>
            </div>

			<div class="display-flex" style="align-items:end;">  
			<label for="datumprijave" class="k-form-field">
            <span>Datum prijave</span>
             <kendo-datepicker id="datumprijave"
                       v-model="prijava.datumprijave"
                       :format="'dd.MM.yyyy'">
            </kendo-datepicker>
            </label>

			<label for="nacin" class="k-form-field flex-grow-1">
                        <span>Način prijave</span>
                        <dropdownlist
                         name="nacin"
                        :data-items="nacinprijaveip"
                        :text-field="'naziv'"
                        v-model="prijava.nacinprijave"
                        />

                        
                </label>
                <router-link title="Preglej prijavo" v-if="eprijava" :to="{ name: 'prijavniObrazecEkoPregled',params:{pridelovalecid:eprijava.pridelovalecid,sezona:eprijava.sezona,shema:eprijava.shema}}"  target="_blank">
                                                 <font-awesome-icon size="2x" icon="file-contract"/>
                        </router-link>
			</div>

			<label for="vrsta" class="k-form-field flex-grow-1">
                        <span>Vrsta prijave</span>
                        <dropdownlist
                         name="vrsta"
                        :data-items="vrstaprijaveip"
                        :text-field="'naziv'"
                        v-model="prijava.vrstaprijave"
                        />
            </label>

			<div class="display-flex" style="align-items:end;">  
			<label for="datumpregleda" class="k-form-field">
            <span>Datum pregleda</span>
             <kendo-datepicker id="datumpregleda"
                       v-model="prijava.datumpregleda"
                       :format="'dd.MM.yyyy'">
            </kendo-datepicker>
            </label>

			<label for="pregledal" class="k-form-field">
            <span>Pregledal</span>
            <input type="text" v-model="prijava.pregledal" placeholder="" name="pregledal" id="pregledal" class="k-textbox" />
            </label>
			</div>

			<div class="display-flex" style="align-items:center;gap:1rem;">  
			<span class="k-form-field">Prijava popolna</span>
			<input type="checkbox" v-model="prijava.popolna"  name="popolnaprijava" id="popolnaprijava" class="k-checkbox k-form-field" />
			<label v-if="prijava.popolna" for="datumpopolnosti" class="k-form-field">
            <kendo-datepicker id="datumpopolnosti"
                       v-model="prijava.datumpopolnosti"
                       :format="'dd.MM.yyyy'">
            </kendo-datepicker>
            </label>

			</div>

			<!-- manjkajoči elementi   -->
			<div style="margin-top:2rem">
            <div class="form-fieldset-header display-flex" style="align-items:center;gap:1rem;">
               <h2 >Manjkajoči elementi</h2>
            </div>
 			<Grid  
                :data-items="prijava.manjkajocielementi"
                :columns='[
                    { field: "datumprejema", title:"Datum prejema",editable:true, type:"date",editor:"date",format:"{0:d}",width: "150px"},
					{ field: "vsebina", title:"Vsebina",editable:true,width: "150px"},
					{ field: "pregledal", title:"Pregledal",editable:true,width: "150px"},
					{ cell: "brisi", filterable: false, width: "220px" }
                        ]'
                        :filterable="false"
                        :sortable="false"
                        @itemchange="manjkajocielementichange"
                        :edit-field="'edit'"
>
<template v-slot:brisi="{props}">
            <button class="k-button k-error " 
                    @click="removemanjkajocielementi(props.dataItem)"
                    >
                    Briši
            </button>
        </template>
    <toolbar>
                             
                        <div class="km-widget km-buttongroup k-widget k-button-group">
                        <button title="Dodaj"
                                class="k-button k-primary"
                                @click="dodajmanjkajocielementi"
                               >
                                Dodaj vrstico
                        </button>
                        </div>
                            
                        </toolbar>
                         <GridNoRecords >
                                        Ni podatkov!
                         </GridNoRecords>
</Grid>
</div>
</fieldset>
</div>

           

     <div class="display-flex pt-1">
     
    <div>
            <fieldset class="left-border-for-children">
                 <div class="form-fieldset-header">
            <h2 >Podatki o kmetiji</h2>
        </div>

         
              <label for="jeaktivna" class="k-form-field k-checkbox-field">
                <span>Je v kontroli (aktivna)</span>
            <input type="checkbox" :disabled="pridelovalec.pisanje==0" v-model="jeaktivna"  name="jeaktivna" id="jeaktivna" class="k-checkbox" />
        </label>

             <label for="kntst" class="k-form-field">
                <span>Kontrolna številka</span>
                
                <input type="text" :disabled="pridelovalec.pisanje==0" v-model="kontrolnastevilka" placeholder="Kontrolna številka" name="kntst" id="kntst" class="k-textbox" />
                 
            </label>
            <label for="vezanarejazivali" class="k-form-field k-checkbox-field">
                <span>Ima vezano rejo</span>
            <input type="checkbox" :disabled="pridelovalec.pisanje==0" v-model="vezanarejazivali"  name="vezanarejazivali" id="vezanarejazivali" class="k-checkbox" />
        </label>
            <!--
              <label for="vezanareja" class="k-form-field k-checkbox-field">
                <span>Kmetija ima vezano rejo živali</span>
            <input type="checkbox" :disabled="pridelovalec.pisanje==0" v-model="imavezanezivali"  name="vezanareja" id="vezanareja" class="k-checkbox" />
        </label>
        <label for="travojedezivali" class="k-form-field k-checkbox-field">
                <span>Kmetija ima travojede živali</span>
            <input type="checkbox" :disabled="pridelovalec.pisanje==0" v-model="imatravojedezivali"  name="travojedezivali" id="travojedezivali" class="k-checkbox" />
        </label>
    -->
<div class="display-flex">
            <label for="status" class="k-form-field flex-grow-1">
                <span>Status</span>
                 <dropdownlist
                @change="spremeniStatus"
                 name="status"
                :data-items="status"
                :text-field="'naziv'"
                :value="izbranStatus"
                :disabled="pridelovalec.pisanje==0"
                
            />
            </label>

            <label for="statusDolocen" class="k-form-field">
                <span>Datum določitve statusa</span>
               <kendo-datepicker :disabled="pridelovalec.pisanje==0" id="statusDolocen"
                       :value="statusDolocen"
                       @change="zamenjajDatum"
                       :min="min"
                      :max="max"
                      :format="'dd.MM.yyyy'"></kendo-datepicker>
            </label>
        </div>
           
        <div class="k-form-field">
                <span>Dejavnosti pridelovalca (certificirane):</span>

                <template v-for="dejavnost in vrsta">
                  <div :class="{
                                 
                                  'prijavadejavnosti':prijavadejavnosti.find(i=>(i.id)==dejavnost.id)
                              }">
                    <label  :for="'dej_chk_'+dejavnost.id" class=" k-checkbox-field" >
                    <input class="k-checkbox" v-model="dejavnostipridelovalca"  type="checkbox" :value="dejavnost.id" :id="'dej_chk_'+dejavnost.id">
                   
                    <span>&nbsp;{{dejavnost.naziv}}</span>
                    </label>
                  </div>
                </template>

           <!--
                <kendo-multiselect :value="vrstapridelovalca"
                        :data-items="vrsta"
                        :text-field="'naziv'"
                        :data-item-key="'id'"
                        :placeholder="'Izberi vrsto'"
                        id="vrstapridelovalca"
                        @change="spremeniVrsto"
                        :messages="multiselectmessages"
                       :disabled="pridelovalec.pisanje==0"
                         :filterable="true"
                        :auto-width="true"
                        >
            </kendo-multiselect>
            -->
        </div>
        <div class="k-form-field">
                <span>Dejavnosti pridelovalca (vse)</span>
            <kendo-multiselect :value="vrstapridelovalcavse"
                        :data-items="vrsta"
                        :text-field="'naziv'"
                        :data-item-key="'id'"
                        :placeholder="'Izberi vrsto'"
                        id="vrstapridelovalca"
                        @change="spremeniVrstoVse"
                        :messages="multiselectmessages"
                       :disabled="pridelovalec.pisanje==0"
                         :filterable="true"
                        :auto-width="true"
                        >
            </kendo-multiselect>
        </div>
      <div class="k-form-field">
                <span>Dejavnosti pridelovalca (kot podizvajalec)</span>
            <kendo-multiselect :value="dejavnostizadruge"
                        :data-items="vrsta"
                        :text-field="'naziv'"
                        :data-item-key="'id'"
                        :placeholder="'Izberi vrsto'"
                        id="dejavnostizadruge"
                        @change="spremeniDejavnostiZaDruge"
                        :messages="multiselectmessages"
                       :disabled="pridelovalec.pisanje==0"
                         :filterable="true"
                        :auto-width="true"
                        >
            </kendo-multiselect>
        </div>
            </fieldset>
             </div>
             
               
          


           
                <div>
                    <fieldset class="left-border-for-children">
                         <div class="form-fieldset-header">
                            <h2 >Certificirane kategorije</h2>
                        </div>
                         <div class="kat_chk_list">
                            <template v-for="kategorija in kategorije">
                                <div :class="{
                                  'izbranakategorija':izbranekategorije.find(i=>(i.id?i.id:i)==kategorija.id),
                                  'prijavakategorije':prijavakategorije.find(i=>(i.id?i.id:i)==kategorija.id)
                              }">
                                <input class="form-check-input" v-model="kategorijepridelovalca"  type="checkbox" :value="kategorija.id" :id="'kat_chk_'+kategorija.id">
                                <label class="form-check-label" :for="'kat_chk_'+kategorija.id" >
                                ({{kategorija.id}}) {{kategorija.naziv}}
                                </label>
                                <dropdownlist style="{ width: '60px';display: 'inline-block';}" :data-items='vrstapridelave' default-value="EK-P"
                                v-model="statuskategorije[kategorija.id]"  @change="handlestatuskategorijechange(kategorija.id,$event)" >
                                </dropdownlist>
                                </div>
                                
                            
                            </template>
                    
        </div>


                    </fieldset>
           
                 </div>
             </div>
        </form>
    </div>
    </div>
    </div>
    </div>

</template>

<script>
import Vue from 'vue';
import {store} from '../store/index.js'
import { mapState, mapActions,mapMutations } from 'vuex'
import { DatePicker } from '@progress/kendo-vue-dateinputs';
import { MultiSelect, DropDownList } from '@progress/kendo-vue-dropdowns';
import { provideIntlService } from '@progress/kendo-vue-intl';
import { Checkbox } from "@progress/kendo-vue-inputs";
import PridelovalecKratko from './support/PridelovalecKratko';
import { Grid, GridToolbar, GridNoRecords  } from '@progress/kendo-vue-grid';
export default {
     components: {
    'kendo-datepicker': DatePicker,
    'kendo-multiselect': MultiSelect,
    'dropdownlist': DropDownList,
    'pridelovalec':PridelovalecKratko,
    'kendo-checkbox': Checkbox,
    'Grid': Grid,
     'GridNoRecords': GridNoRecords,
      'toolbar': GridToolbar,
  },
    props:['sezona','pridelovalecid'],
    data () {
        return {
                  dataSezona:this.sezona,
                   sezone:[],

            kmgmid:"",posta:"",postnastevilka:"",naslov:"",ime:"",priimek:"",telefon:"",email:"",opomba:"",postnastevilkakontakt:"",postakontakt:"",postnastevilkanosilec:"",postnanosilec:"",naslovkontakt:"",priimekkontakt:"",postanosilca:"",postnastevilkanosilca:"",emso:"",imekontakt:"",kntst:"",
            emailnosilca:"",telefonnosilca:"",
            nacinprijaveip:[{naziv:"Pošta",id:0},{naziv:"E-pošta",id:1},{naziv:"Osebno",id:2},{naziv:"E-prijava",id:3}],
			vrstaprijaveip:[{naziv:"Prva prijava",id:0},{naziv:"Obnova prijave",id:1},{naziv:"Obnova prijave zaradi sprememb",id:2}],
			
            eprijava:{},
            
            password: '',
            submitted: false,
            multiselectmessages: 
            {
            "singleTag": "izbrani elementi",
            "clear": "Počisti",
            "deleteTag": "Izbriši",
            "noData": "Ni podatkov"
            },
            prijavakategorije:[],
            prijavadejavnosti:[],
            vrstapridelave:["EK+K","EK-P","P"],
            prijava:{
                datumpopolnosti:null,
                datumpregleda:null,
                datumprijave:null,
                popolna:false,
                nacinprijave:null,
                vrstaprijave:null,
                pregledal:null,
                manjkajocielementi:[]
            },
            
            
            vrsta:[],
            status:[],
            statuskategorije:[],
            kategorije:[],
            min: new Date(2000, 1, 1),
            max: new Date(2100, 31, 12),
        }
    },
    computed: {
        imavezanezivali:
        {
           get() {

            return this.pridelovalec.imavezanezivali>0?true:false;
          },
          set(value) {
            this.updateprop({sezona:this.dataSezona.sezona,shema:"EKO PRI",property:"imavezanezivali",value:value?1:0});

          }
        },
         vrstapridelovalca:
        {
           get() {

            let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRI");

            if (pridelava)
                return pridelava.dejavnosti;
            else
                return [];

          }
        },
         izbranekategorije:
        {
           get() {

            let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRI");

            if (pridelava)
                return pridelava.izbranekategorije;
            else
                return [];

          },
         
        },
        
        kategorijepridelovalca:
        {
           get() {

            let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRI");

            if (pridelava)
                return pridelava.kategorije.map(i=>(i.id?i.id:i));
            else
                return [];

          },
          set(value){

            //let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRI");
            //pridelava.kontrolnaStevilka=value;
            console.log("UPDATE CHKBOX");
            console.log(value);
            this.updateshemaprop({sezona:this.dataSezona.sezona,shema:"EKO PRI",property:"kategorije",value:value.map(i=>{return {id:i,status:this.statuskategorije  [i]}})});
          }
        },
        dejavnostipridelovalca:
        {
           get() {

            let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRI");

            if (pridelava)
                return pridelava.dejavnosti.map(i=>(i.id));
            else
                return [];

          },
          set(value){

            //let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRI");
            //pridelava.kontrolnaStevilka=value;
            console.log("UPDATE CHKBOX dejavnost");
            console.log(value);
            this.updateshemaprop({sezona:this.dataSezona.sezona,shema:"EKO PRI",property:"dejavnosti",value:value.map(i=>{return {id:i,naziv:this.vrsta[i].naziv}})});
          }
        },
        vrstapridelovalcavse:
        {
           get() {

            let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRI");

            if (pridelava)
                return pridelava.vsedejavnosti;
            else
                return [];

          }
        },
        dejavnostizadruge:
        {
           get() {

            let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRI");

            if (pridelava)
                return pridelava.dejavnostizadruge;
            else
                return [];

          }
        },
         kontrolnastevilka:
        {
           get() {

            let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRI");

            if (pridelava)
                return pridelava.kontrolnaStevilka;
            else
                return null;

          },
          set(value){

            //let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRI");
            //pridelava.kontrolnaStevilka=value;
            this.updateshemaprop({sezona:this.dataSezona.sezona,shema:"EKO PRI",property:"kontrolnaStevilka",value:value});
          }

        },
         jeaktivna:
        {
           get() {
            let pridelava=this?.pridelovalec?.sheme?.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRI");

            if (pridelava)
                return pridelava.jeaktivna
            else
              return false;
            
            //return this.pridelovalec.sheme.find(s=>s.sezona==this.sezona&&s.shema=="EKO PRI").jeaktivna>0?true:false;
          },
          set(value) {
            this.updateshemaprop({sezona:this.dataSezona.sezona,shema:"EKO PRI",property:"jeaktivna",value:value?1:0});

          }
        },
        imatravojedezivali:
        {
           get() {

            return this.pridelovalec.imatravojedezivali>0?true:false;
          },
          set(value) {

           this.updateprop({property:"imatravojedezivali",value:value?1:0});

          }
        },
        vezanarejazivali:
        {
           get() {
            let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRI");
            return pridelava.vezanareja;
          },
          set(value) {

            this.updateshemaprop({sezona:this.dataSezona.sezona,shema:"EKO PRI",property:"vezanareja",value:value});

          }
        },
        izbranStatus:
        {
           get() {

             let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRI");

           if (pridelava)
                return this.status.find(s=>s.naziv==pridelava.status);
           else
                return null;
            

          },
          set(value) {
           this.updateshemaprop({sezona:this.dataSezona.sezona,shema:"EKO PRI",property:"status",value:value.naziv});

          }
        },
        statusDolocen:
        {
           get() {
          let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRI");

            if (pridelava&&pridelava.datumDolocitve)
                return provideIntlService(this).parseDate(pridelava.datumDolocitve);
            else
                this.updateshemaprop({sezona:this.dataSezona.sezona,shema:"EKO PRI",property:"datumDolocitve",value:(new Date()).toISOString()});
                return new Date();
             
          },
          set(value) {
       
          
             this.updateshemaprop({sezona:this.dataSezona.sezona,shema:"EKO PRI",property:"datumDolocitve",value:value.toISOString()});
          }
        },
        ...mapState('users', ['sezonePisanje','sheme']),
        ...mapState('pridelava', ['pridelovalec']),
        ...mapState('sifrant', ['sifrant','dataSezone'])
        
    },
    created () {
      if(!this.sezona)
        this.dataSezona={sezona:2022};
      else
      this.dataSezona={sezona:this.sezona};

       //this.naloziPodatke();
       if(!this.shema)
        this.shema="EKO PRI";
       this.naloziPodatke(this.shema,this.sezona,this.pridelovalecid);
     
    },
    beforeRouteUpdate (to, from,next) {
    	this.naloziPodatke(to.params.shema,to.params.sezona,to.params.pridelovalecid,next);
	},
    methods: {
        
        ...mapActions({naloziSifrant: 'sifrant/load'}),
        ...mapActions('pridelava',['loadOne','save','loadIdPoSezoni']),
         ...mapMutations('pridelava',['updateprop','updateshemaprop']),
         
        saveData(e){
          this.save( this.dataSezona);
        },
          handleSubmit(e){

          e.preventDefault();
        },
         cancel(e){
              this.$router.go(-1)
        },
        dodajmanjkajocielementi(){
			console.log("PUSHAM")
            if(!this?.prijava?.manjkajocielementi)
                this.prijava.manjkajocielementi=[];

            const newRecord = { id: this.prijava.manjkajocielementi.length + 1,datumprejema:new Date(),vsebina:'',pregledal:'',edit:true };
            this.prijava.manjkajocielementi.push(newRecord);
        }   ,
        removemanjkajocielementi(e){
        
                var index=this.prijava.manjkajocielementi.indexOf(e);
                if(index>=0)
                        this.prijava.manjkajocielementi.splice(index,1)

        },
        manjkajocielementichange: function (e) {
            e.dataItem[e.field]=e.value;

     
  
},

        handlestatuskategorijechange (id,event)  {
             
            //this.kategorijepridelovalca=this.kategorijepridelovalca.map(i=>{return {id:i,status:event.target.value [i]}});
            console.log("handlestatuskategorijechange");
            console.log(id);
            console.log(event.value);
            let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRI");
            var k=pridelava.kategorije.map(i=>{
                if (i.id==id)
                    return {...i,status:event.value};
                return i;   
            });
            console.log(k);
            this.updateshemaprop({sezona:this.dataSezona.sezona,shema:"EKO PRI",property:"kategorije",value:k});


        },
        spremeniVrstoVse (event)  {
             
             this.updateshemaprop({sezona:this.dataSezona.sezona,shema:"EKO PRI",property:"vsedejavnosti",value:[...event.target.value]});
            
        },
         spremeniVrsto (event)  {
             
             this.updateshemaprop({sezona:this.dataSezona.sezona,shema:"EKO PRI",property:"dejavnosti",value:[...event.target.value]});
            
        },
        spremeniDejavnostiZaDruge (event)  {
             
             this.updateshemaprop({sezona:this.dataSezona.sezona,shema:"EKO PRI",property:"dejavnostizadruge",value:[...event.target.value]});
            
        },
         spremeniStatus (event)  {
              this.izbranStatus=event.target.value;
            
        },
        zamenjajDatum(e){
            console.log(e);
            console.log(e.value);
            
          //če je čudn gmt < +0122 dodaj  

          
          var userTimezoneOffset = (e.value.getTimezoneOffset()+60) * 60000;
          this.statusDolocen=new Date(e.value.getTime() - userTimezoneOffset);
          //tmpdate;
          console.log(this.statusDolocen);
            
        },
       
        naloziPodatke (shema,sezona,pridelovalecid,next){
            // this.dataSezona={sezona:this.sezona};
       // this.dataSezone
//         this.sifrant["statuspridelovalca"]
  //       this.sifrant["vrstapridelovalca"]
         var thisComp=this;
         var psifranti=[
        this.naloziSifrant({sezona:sezona,sifrant:"vrstapridelovalca"}),
        this.naloziSifrant({sezona:sezona,sifrant:"statuspridelovalca"}),
        this.naloziSifrant({sezona:sezona,sifrant:"kategorije"})];
        
        Promise.all(psifranti).then(()=>{

        thisComp.vrsta=thisComp.sifrant["vrstapridelovalca"];
        thisComp.status=thisComp.sifrant["statuspridelovalca"];
        thisComp.kategorije=thisComp.sifrant["kategorije"];
        this.loadOne({sezona:sezona,pridelovalecid:pridelovalecid}).then(p=>{


            let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==sezona&&s.shema=="EKO PRI");
            this.prijavakategorije=[];
            this.prijavadejavnosti=[];
            if (pridelava) {
              //this.pridelava=pridelava;
           
            }
            else {
              //ni vredu
              store.dispatch('alert/error', `Za obstoječo shemo ni podatkov v sezoni ${sezona}`, { root: true });
              this.$router.go(-1);
              //set error message po vseh
            }
            //lansko
            let pridelavalani=this.pridelovalec.sheme.find(s=>s.sezona==(sezona-1)&&s.shema=="EKO PRI");

           


            let eprijava=p.prijave.filter(i=>i.shema=='EKO PRI'&&i.sezona==(sezona*1-1)).sort((a,b)=>(new Date(b.updatedAt)-new Date(a.updatedAt)))[0]
            let novaprijava={
              nacinprijave:null,
              vrstaprijave:null,
              pregledal:'',popolna:false,manjkajocielementi:[],
                        //obseg:{},
              datumpopolnosti:(new Date()).toISOString(),
              datumpregleda:(new Date()).toISOString(),
              //datumprijave:(new Date()).toISOString(),
              seznam:{datotekaid:null,files:[]},
              datumseznama:(new Date()).toISOString()
            };
            if(!pridelava.prijava)
			      {
              Vue.set(pridelava,'prijava',novaprijava)
			      }
           
            if(eprijava){
                console.log("IMAM PRIJAVo!!!")
                
                //način e-prijava
                //Vrsta obnova prijave
                if(!pridelava.prijava.datumprijave)
                    pridelava.prijava.datumprijave=eprijava.prijava.datumoddaje;
                if(!pridelava.prijava.vrstaprijave)
                    pridelava.prijava.vrstaprijave={naziv:"Obnova prijave",id:1};
                if(!pridelava.prijava.nacinprijave)
                    pridelava.prijava.nacinprijave={naziv:"E-prijava",id:3};
                //prenesi davčni zavezanec??
                //default individualno certificiranje, cena po ceniku, prejemnik e-računa, ....
                //kako popraviti kontakte...
                //prenesi gerke
                //naredi povezavo do prijave

                //pridelava.vsedejavnosti
                if(!pridelava.dejavnosti||!pridelava?.dejavnosti?.length)
                pridelava.prijavadejavnosti=eprijava.prijava.dejavnosti.map(i=>{
                  return {id:i,naziv:thisComp.vrsta.find(s=>s.id==i).naziv};
                })
                if(!pridelava.kategorije||!pridelava?.kategorije?.length)
                pridelava.prijavakategorije=eprijava.prijava.kategorije.map(i=>{return {id:i,naziv:thisComp.kategorije.find(s=>s.id==i).naziv}});
                console.log(pridelava);

            

            }
            this.eprijava=eprijava;


            if(!pridelava?.prijava?.popolna)
            {
              //naloži podatke od lani
              if(pridelavalani&&!pridelava.status)
                pridelava.status=`${pridelavalani.status}`;

              //dodaj lanske  dejavnosi
              if((!pridelava.dejavnosti||!pridelava?.dejavnosti?.length)&&pridelavalani)
                  pridelava.dejavnosti=pridelavalani.dejavnosti.map(i=>{return {id:i.id,naziv:i.naziv}})

                //dodaj lanske  kategorije
              if((!pridelava.kategorije||!pridelava?.kategorije?.length)&&pridelavalani)
                pridelava.kategorije=pridelavalani.kategorije.map(i=>{return {id:i.id,status:i.status}})
                 
              
               
                if(pridelava.prijavakategorije){

                  pridelava.prijavakategorije.forEach(i=>{
                    if(!pridelava.kategorije.find(j=>j.id==i.id))
                      pridelava.kategorije.push({id:i.id,status:i.status})
                  })
                  Vue.set(thisComp,"prijavakategorije",pridelava.prijavakategorije)
                } 

                if(pridelava.prijavadejavnosti){

                pridelava.prijavadejavnosti.forEach(i=>{
                  if(!pridelava.dejavnosti.find(j=>j.id==i.id))
                    pridelava.dejavnosti.push({id:i.id,naziv:i.naziv})
                })

                Vue.set(thisComp,"prijavadejavnosti",pridelava.prijavadejavnosti)
         
}



            }

            pridelava.kategorije.forEach(e=>{
                  Vue.set(this.statuskategorije,e.id,e.status);
                });
            pridelava.prijava.datumpregleda=provideIntlService(thisComp).parseDate( pridelava.prijava.datumpregleda);
            pridelava.prijava.datumpopolnosti=provideIntlService(thisComp).parseDate(pridelava.prijava.datumpopolnosti)
			      pridelava.prijava.datumprijave=provideIntlService(thisComp).parseDate(pridelava.prijava.datumprijave)
            pridelava.prijava.manjkajocielementi=pridelava.prijava.manjkajocielementi.map(k=>{
            k["datumprejema"]=provideIntlService(thisComp).parseDate(k["datumprejema"]); 
            return k;
        } ); 
            
            Vue.set(thisComp,"prijava",pridelava.prijava)
           
					  console.log("nastavim status kategorije");
            console.log(this.statuskategorije);

            if(next)
                next();

        });
      }); //konec then šifranti
        },
         sezonaChange(event) {
         

              const sezona = event.value;
            this.dataSezona=sezona;
            //this.loadIdPoSezoni({sezona:sezona.sezona,pridelovalecid:this.pridelovalecid}).then(pridelovalec=>{
              //this.pridelovalecid=pridelovalec.id;
             //this.$router.push({ name: 'pridelovalec', params: {sezona:sezona.sezona,pridelovalecid:this.pridelovalecid} });
             
            
             let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==sezona.sezona&&s.shema=="EKO PRI");
            if (pridelava) {
              //this.pridelava=pridelava;
              this.$router.push({ name: 'pridelovalec', params: { sezona:sezona.sezona,shema:this.shema,pridelovalecid:this.pridelovalecid} })
            }
            else {
              //ni vredu
              store.dispatch('alert/error', `Za obstoječo shemo ni podatkov v sezoni ${sezona.sezona}`, { root: true });
            }
              
             //this.naloziPodatke();
              //});


          //  this.naloziPodatke();



        },
    }
};
</script>

<style scoped>

.izbranakategorija{
   background-color: var(--accent);
   
}
.prijavadejavnosti,.prijavakategorije{
   background-color: var(--warning);
   
}

.k-checkbox-field {
    display: flex !important;
    align-items: center;
}
.kat_chk_list{
display:flex;
flex-direction:column;

}

form {
display:flex;
flex-direction:column;
}

.k-checkbox-field input[type="checkbox"]{
    margin-left: 0.5rem;

}
</style>